import React, { useState, useEffect, useContext, useRef } from 'react';
import {
	Container,
	Stack,
	AppBar,
	Toolbar,
	Typography,
	Dialog,
	IconButton,
	TableContainer,
	Table,
	TableCell,
	TableRow,
	TableHead,
	TableBody,
	Divider
} from '@mui/material';
import { isEmpty } from 'lodash';

import { useParams } from 'react-router-dom';
import { DataContext } from '../../../context/DataContext';
import { simpleMessage } from '../../../helpers/Helpers';
import { getToken, getUser } from '../../../api/Account';
import ReactToPrint from 'react-to-print';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import NoData from '../../../components/NoData';
import { getNewClientsAsync } from '../../../api/Report';
import { PrintReport } from '../../../components/PrintReport';
import moment from 'moment';
import { getUsuariosListAsync } from '../../../api/Users';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx/xlsx.mjs';

const NewClients = () => {
	const [data, setData] = useState([]);

	const compRef = useRef();
	const { selectedGestor, fechaDesde, fechaHasta } = useParams();

	const { setIsLoading, setIsUnautorized, title, slogan, icon } = useContext(DataContext);

	const [gestorName, setGestorName] = useState('');
	const [gestorList, setGestorList] = useState([]);

	const token = getToken();
	const user = getUser();

	useEffect(() => {
		(async () => {
			let gestores = await getGestores(token);
			if (selectedGestor === 't') {
				setGestorName('Todos');
			} else {
				let name = gestores.filter((item) => item.id.toString() === selectedGestor);
				setGestorName(name[0].fullName);
			}

			const data = {
				desde: fechaDesde.toString(),
				hasta: fechaHasta.toString(),
				gestorId: selectedGestor === 't' ? 0 : selectedGestor
			};

			setIsLoading(true);
			const result = await getNewClientsAsync(token, data);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setData(result.data.result);
			setIsLoading(false);
		})();
	}, []);

	const getGestores = async () => {
		setIsLoading(true);
		const result = await getUsuariosListAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setIsLoading(false);

		setGestorList(
			selectedGestor === 't'
				? result.data.result
				: result.data.result.filter((g) => g.id.toString() === selectedGestor)
		);
		return result.data.result;
	};

	const pageStyle = `
  @media all {
    .pagebreak {
      display: none;
    }
  }

  @media print {
    .pagebreak {
      page-break-before: always;
    }
  }
  
  @page { size: landscape;  margin: 8mm; }
`;

	const exportExcel = () => {
		let exp = [];

		data.map((item) => {
			const dataGestor = gestorList.filter((gestor) => gestor.id === item.gestor);
			let gestor = dataGestor[0];
			let obj = {
				id: item.id,
				actividadEconomica: item.actividadEconomica,
				direccion: item.address,
				ciclos: item.ciclos,
				company: item.company,
				fullName: item.fullName,
				cedula: item.identification,
				telefono: item.phone,
				actividadEconomica: item.actividadEconomica,
				promedio: item.promedio,
				gestor: gestor.fullName,
				referencias: item.referencias
			};

			exp.push(obj);
		});
		var bk = XLSX.utils.book_new(),
			bs = XLSX.utils.json_to_sheet(exp);

		XLSX.utils.book_append_sheet(bk, bs, 'clientesNuevos');
		XLSX.writeFile(bk, 'ClientesNuevos.xlsx');
	};

	let consolN = 0;
	let consolR = 0;
	let consolNR = 0;

	return (
		<div>
			<Dialog fullScreen open={true}>
				<AppBar sx={{ position: 'relative' }}>
					<Toolbar>
						<img loading="lazy" src={icon} alt="logo" style={{ height: 40 }} />
						<Typography
							sx={{ ml: 2, flex: 1, textAlign: 'center' }}
							variant="h5"
							component="div"
						>
							{`${title} `}
						</Typography>
						<img loading="lazy" src={icon} alt="logo" style={{ height: 40 }} />
					</Toolbar>
				</AppBar>

				<Stack display="flex" justifyContent="center">
					<Stack
						direction={'row'}
						justifyContent="space-between"
						paddingLeft={5}
						paddingRight={5}
						marginTop={1}
						marginBottom={1}
					>
						<IconButton variant="outlined" onClick={() => exportExcel()}>
							<FontAwesomeIcon
								icon={faCloudArrowDown}
								style={{ fontSize: 40, color: '#00a152', width: 40 }}
							/>
						</IconButton>

						<Stack>
							<Typography
								sx={{
									color: '#2196f3',
									textAlign: 'center',
									fontWeight: 'bold'
								}}
							>
								{slogan}
							</Typography>
							<Typography
								sx={{
									color: '#2196f3',
									textAlign: 'center',
									fontWeight: 'bold'
								}}
								variant="h6"
								component="div"
							>
								Reporte de Clientes Nuevos
							</Typography>
						</Stack>

						<ReactToPrint
							trigger={() => {
								return (
									<IconButton
										variant="outlined"
										// style={{ position: "fixed", right: 20, top: 75 }}
									>
										<PrintRoundedIcon
											style={{ fontSize: 40, color: '#2979ff', width: 40 }}
										/>
									</IconButton>
								);
							}}
							content={() => compRef.current}
							pageStyle={pageStyle}
						/>
					</Stack>

					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<Stack direction={'row'} justifyContent="space-between">
							<Stack>
								<Typography
									sx={{
										color: '#2196f3',
										textAlign: 'left'
									}}
									fontSize={11}
								>
									Parametros:
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{`Gestor Seleccionado: ${
										selectedGestor === 't' ? 'Todos' : gestorName
									}`}
								</Typography>

								<Typography fontSize={11} textAlign="left">
									{`Desde: ${moment(fechaDesde).format('L')} - Hasta ${moment(
										fechaHasta
									).format('L')}`}
								</Typography>
							</Stack>

							<Stack>
								<Typography
									sx={{
										color: '#2196f3',
										textAlign: 'left'
									}}
									fontSize={11}
								>
									Usuario:
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{user}
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{`Fecha y Hora: ${moment().format('DD/MM/YYYY hh:mm A')}`}
								</Typography>
							</Stack>
						</Stack>
					</Container>
				</Stack>

				<Container maxWidth={false} sx={{ textAlign: 'center' }}>
					<hr />
					{isEmpty(data) ? (
						<NoData />
					) : (
						<>
							{gestorList.map((gestor) => {
								const cGestor = data.filter((c) => c.userId === gestor.id);

								let contadorN = 0;
								let contadorR = 0;
								let contadorNR = 0;

								cGestor.map((c) => {
									if (c.tipo === 'N') {
										contadorN += 1;
									} else if (c.tipo === 'R') {
										contadorR += 1;
									} else {
										contadorNR += 1;
									}
								});

								consolN += contadorN;
								consolR += contadorR;
								consolNR += contadorNR;

								return (
									<Stack key={gestor.id}>
										<Stack direction="row" spacing={1}>
											<Typography
												sx={{
													color: '#2196f3',
													textAlign: 'left'
												}}
												fontSize={11}
											>
												Gestor:
											</Typography>
											<Typography
												sx={{
													textAlign: 'left'
												}}
												fontSize={11}
											>
												{gestor.fullName}
											</Typography>
										</Stack>
										<Divider />
										{isEmpty(cGestor) ? (
											<Typography
												sx={{
													color: '#2196f3',
													textAlign: 'center',
													fontWeight: 'bold'
												}}
												fontSize={15}
											>
												Gestor no tiene clientes para cobrar!
											</Typography>
										) : (
											<>
												<TableContainer>
													<Table aria-label="simple table" size="small">
														<TableHead>
															<TableRow>
																<TableCell
																	align="center"
																	className="text-primary fw-bold"
																	style={{ fontSize: 9 }}
																>
																	#
																</TableCell>
																<TableCell
																	align="left"
																	className="text-primary fw-bold"
																	style={{ fontSize: 9 }}
																>
																	Cliente
																</TableCell>
																<TableCell
																	align="center"
																	className="text-primary fw-bold"
																	style={{ fontSize: 9 }}
																>
																	Cedula
																</TableCell>
																<TableCell
																	align="center"
																	className="text-primary fw-bold"
																	style={{ fontSize: 9 }}
																>
																	Teléfono
																</TableCell>

																<TableCell
																	align="left"
																	className="text-primary fw-bold"
																	style={{ fontSize: 9 }}
																>
																	Dirección
																</TableCell>

																<TableCell
																	align="left"
																	className="text-primary fw-bold"
																	style={{ fontSize: 9 }}
																>
																	A.Economica
																</TableCell>
																<TableCell
																	align="center"
																	className="text-primary fw-bold"
																	style={{ fontSize: 9 }}
																>
																	Ciclos
																</TableCell>
																<TableCell
																	align="center"
																	className="text-primary fw-bold"
																	style={{ fontSize: 9 }}
																>
																	Tipo
																</TableCell>
																<TableCell
																	align="left"
																	className="text-primary fw-bold"
																	style={{ fontSize: 9 }}
																>
																	Gestor
																</TableCell>
															</TableRow>
														</TableHead>
														<TableBody>
															{cGestor.map((row) => {
																return (
																	<TableRow key={row.id}>
																		<TableCell
																			align="center"
																			component="th"
																			scope="row"
																			style={{ fontSize: 8 }}
																		>
																			{row.id}
																		</TableCell>
																		<TableCell
																			align="left"
																			scope="row"
																			style={{ fontSize: 8 }}
																		>
																			{row.fullName}
																		</TableCell>
																		<TableCell
																			align="center"
																			scope="row"
																			style={{ fontSize: 8 }}
																		>
																			{row.identification}
																		</TableCell>
																		<TableCell
																			align="center"
																			scope="row"
																			style={{ fontSize: 8 }}
																		>
																			{row.phone}
																		</TableCell>
																		<TableCell
																			align="left"
																			scope="row"
																			style={{ fontSize: 8 }}
																		>
																			{row.address}
																		</TableCell>

																		<TableCell
																			align="left"
																			scope="row"
																			style={{ fontSize: 8 }}
																		>
																			{row.actividadEconomica}
																		</TableCell>
																		<TableCell
																			align="center"
																			scope="row"
																			style={{ fontSize: 8 }}
																		>
																			{row.ciclos}
																		</TableCell>
																		<TableCell
																			align="center"
																			scope="row"
																			style={{ fontSize: 8 }}
																		>
																			{row.tipo}
																		</TableCell>
																		<TableCell
																			align="left"
																			style={{ fontSize: 8 }}
																		>
																			{row.creadoPor}
																		</TableCell>
																	</TableRow>
																);
															})}
														</TableBody>
													</Table>
												</TableContainer>

												<hr />
												<Stack
													direction="row"
													flex="row"
													justifyContent="space-around"
												>
													<Stack textAlign="center">
														<Typography
															style={{
																fontWeight: 'bold',
																color: '#03a9f4',
																fontSize: 11
															}}
														>
															Total Créditos
														</Typography>
														<Typography style={{ fontSize: 11 }}>
															{cGestor.length}
														</Typography>
													</Stack>

													<Stack textAlign="center">
														<Typography
															style={{
																fontWeight: 'bold',
																color: '#03a9f4',
																fontSize: 11
															}}
														>
															Total Nuevos
														</Typography>
														<Typography style={{ fontSize: 11 }}>
															{contadorN}
														</Typography>
													</Stack>

													<Stack textAlign="center">
														<Typography
															style={{
																fontWeight: 'bold',
																color: '#03a9f4',
																fontSize: 11
															}}
														>
															Total Renovados
														</Typography>
														<Typography style={{ fontSize: 11 }}>
															{contadorR}
														</Typography>
													</Stack>

													<Stack textAlign="center">
														<Typography
															style={{
																fontWeight: 'bold',
																color: '#03a9f4',
																fontSize: 11
															}}
														>
															Total Nuevos Renovado
														</Typography>
														<Typography style={{ fontSize: 11 }}>
															{contadorNR}
														</Typography>
													</Stack>
												</Stack>
												<hr />
											</>
										)}
									</Stack>
								);
							})}
						</>
					)}

					{gestorList.length === 1 ? (
						<></>
					) : (
						<Stack>
							<Typography
								sx={{
									color: '#2196f3',
									textAlign: 'center'
								}}
							>
								Consolidado
							</Typography>

							<hr />

							<Stack direction="row" flex="row" justifyContent="space-around">
								<Stack textAlign="center">
									<Typography
										style={{
											fontWeight: 'bold',
											color: '#03a9f4',
											fontSize: 11
										}}
									>
										T. Creditos del Día
									</Typography>
									<Typography style={{ fontSize: 11 }}>{data.length}</Typography>
								</Stack>

								<Stack textAlign="center">
									<Typography
										style={{
											fontWeight: 'bold',
											color: '#03a9f4',
											fontSize: 11
										}}
									>
										Consolidado Nuevos
									</Typography>
									<Typography style={{ fontSize: 11 }}>{consolN}</Typography>
								</Stack>

								<Stack textAlign="center">
									<Typography
										style={{
											fontWeight: 'bold',
											color: '#03a9f4',
											fontSize: 11
										}}
									>
										Consolidado Renovados
									</Typography>
									<Typography style={{ fontSize: 11 }}>{consolR}</Typography>
								</Stack>

								<Stack textAlign="center">
									<Typography
										style={{
											fontWeight: 'bold',
											color: '#03a9f4',
											fontSize: 11
										}}
									>
										Consolidado Nuevos Renovado
									</Typography>
									<Typography style={{ fontSize: 11 }}>{consolNR}</Typography>
								</Stack>
							</Stack>

							<hr />
						</Stack>
					)}
				</Container>
			</Dialog>

			<div
				style={{
					display: 'none'
				}}
			>
				<PrintReport
					ref={compRef}
					titulo={'Reporte de Clientes Nuevos'}
					fecha={`Fecha: ${moment().format('L')}`}
				>
					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<Stack direction={'row'} justifyContent="space-between">
							<Stack>
								<Typography
									sx={{
										color: '#2196f3',
										textAlign: 'left'
									}}
									fontSize={11}
								>
									Parametros:
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{`Gestor Seleccionado: ${
										selectedGestor === 't' ? 'Todos' : gestorName
									}`}
								</Typography>

								<Typography fontSize={11} textAlign="left">
									{`Desde: ${moment(fechaDesde).format('L')} - Hasta ${moment(
										fechaHasta
									).format('L')}`}
								</Typography>
							</Stack>

							<Stack>
								<Typography
									sx={{
										color: '#2196f3',
										textAlign: 'left'
									}}
									fontSize={11}
								>
									Usuario:
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{user}
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{`Fecha y Hora: ${moment().format('DD/MM/YYYY hh:mm A')}`}
								</Typography>
							</Stack>
						</Stack>
					</Container>

					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<hr />
						{isEmpty(data) ? (
							<NoData />
						) : (
							<>
								{gestorList.map((gestor) => {
									const cGestor = data.filter((c) => c.userId === gestor.id);

									let contadorN = 0;
									let contadorR = 0;
									let contadorNR = 0;

									cGestor.map((c) => {
										if (c.tipo === 'N') {
											contadorN += 1;
										} else if (c.tipo === 'R') {
											contadorR += 1;
										} else {
											contadorNR += 1;
										}
									});

									consolN += contadorN;
									consolR += contadorR;
									consolNR += contadorNR;

									return (
										<Stack key={gestor.id}>
											<Stack direction="row" spacing={1}>
												<Typography
													sx={{
														color: '#2196f3',
														textAlign: 'left'
													}}
													fontSize={11}
												>
													Gestor:
												</Typography>
												<Typography
													sx={{
														textAlign: 'left'
													}}
													fontSize={11}
												>
													{gestor.fullName}
												</Typography>
											</Stack>
											<Divider />
											{isEmpty(cGestor) ? (
												<Typography
													sx={{
														color: '#2196f3',
														textAlign: 'center',
														fontWeight: 'bold'
													}}
													fontSize={15}
												>
													Gestor no tiene clientes para cobrar!
												</Typography>
											) : (
												<>
													<TableContainer>
														<Table
															aria-label="simple table"
															size="small"
														>
															<TableHead>
																<TableRow>
																	<TableCell
																		align="center"
																		className="text-primary fw-bold"
																		style={{ fontSize: 9 }}
																	>
																		#
																	</TableCell>
																	<TableCell
																		align="left"
																		className="text-primary fw-bold"
																		style={{ fontSize: 9 }}
																	>
																		Cliente
																	</TableCell>
																	<TableCell
																		align="center"
																		className="text-primary fw-bold"
																		style={{ fontSize: 9 }}
																	>
																		Cedula
																	</TableCell>
																	<TableCell
																		align="center"
																		className="text-primary fw-bold"
																		style={{ fontSize: 9 }}
																	>
																		Teléfono
																	</TableCell>

																	<TableCell
																		align="left"
																		className="text-primary fw-bold"
																		style={{ fontSize: 9 }}
																	>
																		Dirección
																	</TableCell>

																	<TableCell
																		align="left"
																		className="text-primary fw-bold"
																		style={{ fontSize: 9 }}
																	>
																		A.Economica
																	</TableCell>
																	<TableCell
																		align="center"
																		className="text-primary fw-bold"
																		style={{ fontSize: 9 }}
																	>
																		Ciclos
																	</TableCell>
																	<TableCell
																		align="center"
																		className="text-primary fw-bold"
																		style={{ fontSize: 9 }}
																	>
																		Tipo
																	</TableCell>
																	<TableCell
																		align="left"
																		className="text-primary fw-bold"
																		style={{ fontSize: 9 }}
																	>
																		Gestor
																	</TableCell>
																</TableRow>
															</TableHead>
															<TableBody>
																{cGestor.map((row) => {
																	return (
																		<TableRow key={row.id}>
																			<TableCell
																				align="center"
																				component="th"
																				scope="row"
																				style={{
																					fontSize: 8
																				}}
																				className="text-dark"
																			>
																				{row.id}
																			</TableCell>
																			<TableCell
																				align="left"
																				scope="row"
																				style={{
																					fontSize: 8
																				}}
																				className="text-dark"
																			>
																				{row.fullName}
																			</TableCell>
																			<TableCell
																				align="center"
																				scope="row"
																				style={{
																					fontSize: 8
																				}}
																				className="text-dark"
																			>
																				{row.identification}
																			</TableCell>
																			<TableCell
																				align="center"
																				scope="row"
																				style={{
																					fontSize: 8
																				}}
																				className="text-dark"
																			>
																				{row.phone}
																			</TableCell>
																			<TableCell
																				align="left"
																				scope="row"
																				style={{
																					fontSize: 8
																				}}
																				className="text-dark"
																			>
																				{row.address}
																			</TableCell>

																			<TableCell
																				align="left"
																				scope="row"
																				style={{
																					fontSize: 8
																				}}
																				className="text-dark"
																			>
																				{
																					row.actividadEconomica
																				}
																			</TableCell>
																			<TableCell
																				align="center"
																				scope="row"
																				style={{
																					fontSize: 8
																				}}
																				className="text-dark"
																			>
																				{row.ciclos}
																			</TableCell>
																			<TableCell
																				align="center"
																				scope="row"
																				style={{
																					fontSize: 8
																				}}
																				className="text-dark"
																			>
																				{row.tipo}
																			</TableCell>
																			<TableCell
																				align="left"
																				style={{
																					fontSize: 8
																				}}
																				className="text-dark"
																			>
																				{row.creadoPor}
																			</TableCell>
																		</TableRow>
																	);
																})}
															</TableBody>
														</Table>
													</TableContainer>

													<hr />
													<Stack
														direction="row"
														flex="row"
														justifyContent="space-around"
													>
														<Stack textAlign="center">
															<Typography
																style={{
																	fontWeight: 'bold',
																	color: '#03a9f4',
																	fontSize: 11
																}}
															>
																Total Créditos
															</Typography>
															<Typography style={{ fontSize: 11 }}>
																{cGestor.length}
															</Typography>
														</Stack>

														<Stack textAlign="center">
															<Typography
																style={{
																	fontWeight: 'bold',
																	color: '#03a9f4',
																	fontSize: 11
																}}
															>
																Total Nuevos
															</Typography>
															<Typography style={{ fontSize: 11 }}>
																{contadorN}
															</Typography>
														</Stack>

														<Stack textAlign="center">
															<Typography
																style={{
																	fontWeight: 'bold',
																	color: '#03a9f4',
																	fontSize: 11
																}}
															>
																Total Renovados
															</Typography>
															<Typography style={{ fontSize: 11 }}>
																{contadorR}
															</Typography>
														</Stack>

														<Stack textAlign="center">
															<Typography
																style={{
																	fontWeight: 'bold',
																	color: '#03a9f4',
																	fontSize: 11
																}}
															>
																Total Nuevos Renovado
															</Typography>
															<Typography style={{ fontSize: 11 }}>
																{contadorNR}
															</Typography>
														</Stack>
													</Stack>
													<hr />
												</>
											)}
										</Stack>
									);
								})}
							</>
						)}

						{gestorList.length === 1 ? (
							<></>
						) : (
							<Stack>
								<Typography
									sx={{
										color: '#2196f3',
										textAlign: 'center'
									}}
								>
									Consolidado
								</Typography>

								<hr />

								<Stack direction="row" flex="row" justifyContent="space-around">
									<Stack textAlign="center">
										<Typography
											style={{
												fontWeight: 'bold',
												color: '#03a9f4',
												fontSize: 11
											}}
										>
											T. Creditos del Día
										</Typography>
										<Typography style={{ fontSize: 11 }}>
											{data.length}
										</Typography>
									</Stack>

									<Stack textAlign="center">
										<Typography
											style={{
												fontWeight: 'bold',
												color: '#03a9f4',
												fontSize: 11
											}}
										>
											Consolidado Nuevos
										</Typography>
										<Typography style={{ fontSize: 11 }}>{consolN}</Typography>
									</Stack>

									<Stack textAlign="center">
										<Typography
											style={{
												fontWeight: 'bold',
												color: '#03a9f4',
												fontSize: 11
											}}
										>
											Consolidado Renovados
										</Typography>
										<Typography style={{ fontSize: 11 }}>{consolR}</Typography>
									</Stack>

									<Stack textAlign="center">
										<Typography
											style={{
												fontWeight: 'bold',
												color: '#03a9f4',
												fontSize: 11
											}}
										>
											Consolidado Nuevos Renovado
										</Typography>
										<Typography style={{ fontSize: 11 }}>{consolNR}</Typography>
									</Stack>
								</Stack>

								<hr />
							</Stack>
						)}
					</Container>
				</PrintReport>
			</div>
		</div>
	);
};

export default NewClients;
